import { useLoaderData,useParams,useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import useRegionalStore from "../store/useRegionalStore.js";
export async function homeLoader() {
    const res = await fetch(`/indonesia_provinces.json`);
    return res.json();
}
export default function FilterPage() {
 const {addprovince, addregency,adddistrict,reset, delregency,deldistrict } = useRegionalStore()
 const provinces = useLoaderData();
 const navigate = useNavigate();
 const { id , id2 , id3 } = useParams();
 const [regenciesList,setRegenciesList] = useState([])
 const [districtList,setDistrictList] = useState([])
 

 useEffect(()=> {
    bindRegencies()
},[id])

 useEffect(()=> {
     bindDistrict()
    
},[id2])
  
const bindRegencies = async () => {
    const res = await fetch(`/indonesia_regencies.json`)
    const arr = await res.json()
    setRegenciesList(arr.filter((item) => item.province_id == id))
}

const bindDistrict = async () => {
    const res = await fetch(`/indonesia_districts.json`)
    const arr = await res.json()
    setDistrictList(arr.filter((item) => item.regency_id == id2))
}

return(
        <>
        <div className="m-1">
            <span className="mb-5 flex text-gray-800 text-sm">FILTER WILAYAH</span>
            <span className="text-gray-800 text-sm">PROVINSI</span>
            <div>
                <select  name="province" className="rounded w-full h-8 text-gray-800 mb-5" value={id} onChange={(e) => {
                            delregency()
                            deldistrict()
                            addprovince(provinces.filter((item=>item.id == e.target.value))[0]?.name); 
                            navigate(`/${e.target.value}/${id2 || 0 }/${id3 || 0}`)
                            setDistrictList([])
                        }}>
                    <option value={0}>----- Pilih Provinsi -----</option>
                    {provinces.map(province => (
                        <option value={province.id} >{province.name}</option>
                    ))}
                </select>
            
            </div>
          <span className="text-gray-800 text-sm">KOTA/KABUPATEN</span>
            <div>
                <select name="regency" className="rounded w-full h-8 text-gray-800 mb-5" value={id2} onChange={(e) => { 
                         deldistrict()
                        addregency(regenciesList.filter((item=>item.id == e.target.value))[0]?.name); 
                        navigate(`/${id}/${e.target.value}/${id3}`)
                    }}>
                    <option value={0}>----- Pilih Kabupaten -----</option>
                    {regenciesList.map(regency => (
                        <option value={regency.id} >{regency.name}</option>
                    ))}
                </select>
            
            </div>
            <span className="text-gray-800 text-sm">KECAMATAN</span>
            <div>
                <select name="district" className="rounded w-full h-8 text-gray-800 mb-5" value={id3} onChange={(e) => {
                        adddistrict(districtList.filter((item=>item.id == e.target.value))[0]?.name);  
                        navigate(`/${id}/${id2}/${e.target.value}`)
                       
                    }}>
                    
                    <option value={0}>----- Pilih Kecamatan -----</option>
                    {districtList.map(disctrict => (
                        <option value={disctrict.id} >{disctrict.name}</option>
                    ))}
                </select>
            
            </div>
            <div>
                <button className="bg-slate-200 border border-indigo-600 w-full hover:bg-blue-700 text-black  text-sm py-2 px-4 rounded" onClick={(e)=> {
                    navigate('/0/0/0')
                    reset();
                    }}>RESET</button>
            </div>
        </div>
        </>
    )
}